// Reactive touch/mobile signal — drives both layout (leaderboard drawer, resource HUD
// stacking) and interaction model (tap-to-overlay instead of hover) across the game UI.
// A device counts as mobile if it has no real hover (coarse pointer) or the viewport is
// narrow enough that the desktop layout wouldn't fit — either condition alone is enough,
// so e.g. a touch laptop keeps the desktop layout when wide, and a narrow desktop window
// still gets the compact mobile layout.
const MOBILE_MAX_WIDTH = 768;
function computeIsMobile() {
    return (window.matchMedia("(pointer: coarse)").matches ||
        window.innerWidth <= MOBILE_MAX_WIDTH);
}
let current = computeIsMobile();
const listeners = new Set();
window.addEventListener("resize", () => {
    const next = computeIsMobile();
    if (next === current)
        return;
    current = next;
    for (const cb of listeners)
        cb(current);
});
export function isMobile() {
    return current;
}
// Registers a callback fired whenever the mobile/desktop classification flips (e.g. a
// device rotation or window resize crosses MOBILE_MAX_WIDTH). Listeners are never removed —
// all current call sites are singleton DOM panels that live for the app's lifetime.
export function onMobileChange(cb) {
    listeners.add(cb);
}
